import { Box, Stack, Typography } from '@mui/material';
import { FunctionField, useTranslate } from 'react-admin';
import ActiveIcon from '@/assets/icons/active-icon.svg?react';
import NotificationDefaultIcon from '@/assets/icons/notification-default-icon.svg?react';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)({
    display: 'flex',
    padding: '0',
    alignItems: 'flex-start',
    '&:first-of-type': {
        marginBottom: '3px',
    },
    '& .icon': {
        paddingRight: '10px',
    },
    '& .label': {
        fontSize: '14px',
        lineHeight: '20px',
        letterSpacing: '-0.14px',
    },
    '& .number': {
        paddingLeft: '2px',
        fontWeight: '600',
    },
});

const Row = ({ icon, label, number }) => (
    <StyledBox>
        <Box className='icon'>{icon}</Box>
        <Typography variant='caption' className='label'>
            {`${label}: `}
            <span className='number'>{number}</span>
        </Typography>
    </StyledBox>
);

const GroupDevicesStateField = () => {
    const translate = useTranslate();
    return (
        <FunctionField
            render={record => (
                <Stack sx={{ padding: '6px 0' }}>
                    <Row icon={<ActiveIcon />} label={translate('resources.deviceGroup.labels.correctOperation')} number={record.activeDeviceCount} />
                    <Row
                        icon={<NotificationDefaultIcon />}
                        label={translate('resources.deviceGroup.labels.incorrectOperation')}
                        number={record.inactiveDeviceCount}
                    />
                </Stack>
            )}
        />
    );
};

export default GroupDevicesStateField;
